var exports = {
  "UX": "PlutoniumUpsell.module__upsell___RTFfV0",
  "Kk": "PlutoniumUpsell.module__icon___RTFfV0",
  "Qs": "PlutoniumUpsell.module__content___RTFfV0",
  "Qq": "PlutoniumUpsell.module__text___RTFfV0",
  "o1": "PlutoniumUpsell.module__actions___RTFfV0",
  "R3": "PlutoniumUpsell.module__dismissLink___RTFfV0",
};

module.exports = exports;
